import { useCallback } from 'react'

type RefDelegateFn<T> = (node: T | null) => void

/**
 * Combines multiple refs into a single ref.
 */
const useRefDelegate = <T>(refs: RefDelegateFn<T>[]) =>
  useCallback<RefDelegateFn<T>>(
    (node) => {
      refs.map((ref) => ref(node))
    },
    [refs],
  )

export default useRefDelegate
